import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { PriceDuelHero } from './components/PriceDuelHero';
import { BrutalTruth } from './components/BrutalTruth';
import { MakersPoverty } from './components/MakersPoverty';
import { Revelation } from './components/Revelation';
import { MakerProof } from './components/MakerProof';
import { ValueStack } from './components/ValueStack';
import { ProProof } from './components/ProProof';
import { Ultimatum } from './components/Ultimatum';
import { Guarantee } from './components/Guarantee';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="28sbbx5a2f776">
      <div className="w-full min-h-full bg-cream font-heading text-ink antialiased" data-id="element-1" data-mp="23vcmh01cjofb">
        <UrgencyBar data-id="element-2" data-mp="23ti6m04xmmi3" />
        <main data-id="element-3" data-mp="3ik7jmqgv0tve">
          <PriceDuelHero data-id="element-4" data-mp="3ikqz80j1f669" />
          <BrutalTruth data-id="element-5" data-mp="3ijfv1zlojwem" />
          <MakersPoverty data-id="element-6" data-mp="3ii4t85bsoyq5" />
          <Revelation data-id="element-7" data-mp="3mlat8v8bdto6" />
          <MakerProof data-id="element-8" data-mp="3mkhm3t5g125i" />
          <ValueStack data-id="element-9" data-mp="3mjzpuwis6nxl" />
          <ProProof data-id="element-10" data-mp="3mj6hxs835sdv" />
          <Ultimatum data-id="element-11" data-mp="3rcj8i7wbs999" />
          <Guarantee data-id="element-12" data-mp="3rdaqgfx028h2" />
          <FaqSection data-id="element-13" data-mp="3rcsw5otwe4bs" />
          <FinalCta data-id="element-14" data-mp="3recc1ebn6dd1" />
        </main>
        <noscript data-id="element-15" data-mp="6hq1ea16ddl">
          <img height="1" width="1" style={{
          display: 'none'
        }} src="https://www.facebook.com/tr?id=2243850073137099&ev=PageView&noscript=1" alt="" data-id="element-16" data-mp="4ww9qvjiygs" />
        </noscript>
      </div>
    </CountdownProvider>;
}